var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAkarIconsSearch = function SvgAkarIconsSearch(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_363_4862)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0768 14.8493L11.0862 11.8533M12.7435 7.84928C12.7435 9.35218 12.1465 10.7935 11.0838 11.8562C10.0211 12.9189 8.57972 13.516 7.07682 13.516C5.57393 13.516 4.13259 12.9189 3.06988 11.8562C2.00718 10.7935 1.41016 9.35218 1.41016 7.84928C1.41016 6.34639 2.00718 4.90505 3.06988 3.84235C4.13259 2.77964 5.57393 2.18262 7.07682 2.18262C8.57972 2.18262 10.0211 2.77964 11.0838 3.84235C12.1465 4.90505 12.7435 6.34639 12.7435 7.84928V7.84928Z",
    stroke: "#909090",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_363_4862"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.078125 0.84668)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAkarIconsSearch);
export default ForwardRef;